import instance from '../axios-instance';
export const addWorkflow = async <T>(data: T): Promise<any> => {
  return (await instance.post(`app/workflows`, data)).data.data;
};

export const updateWorkflow = async <T>(data: T, id: number): Promise<any> => {
  return (await instance.post(`app/workflows/${id}?_method=PUT`, data)).data
    .data;
};

export const updateTrigger = async <T>(data: T, id: number): Promise<any> => {
  return (
    await instance.post(`app/workflows/update-trigger/${id}?_method=PUT`, data)
  ).data.data;
};
export const updateAction = async <T>(data: T, id: number): Promise<any> => {
  return (
    await instance.post(`app/workflows/update-action/${id}?_method=PUT`, data)
  ).data.data;
};

export const createAction = async <T>(data: T, id: number): Promise<any> => {
  return (
    await instance.post(`app/workflows/create-action/${id}?_method=PUT`, data)
  ).data.data;
};
export const deleteWorkflow = async (id: number) => {
  return (await instance.delete(`app/workflows/${id}`)).data;
};
